import { PixelEventService } from '@websky/pixel';
import type { EventMessage } from '@websky/pixel';
import { Log } from '../../../../sentry';

export const sendPixelEvent = async (buildEvent: (cdpId: string) => EventMessage): Promise<void> => {
	try {
		if (!window.__webskyEngineConfig?.global?.usePixel) {
			return;
		}

		const pixelService = PixelEventService.getInstance();

		if (!pixelService.isReady()) {
			await pixelService.initialize();
		}

		const cdpId = pixelService.getCdpId();
		if (cdpId) {
			await pixelService.sendEvent(buildEvent(cdpId));
		}
	} catch (error) {
		Log({
			level: 'error',
			message: `SendPixelEvent error: ${error instanceof Error ? error.message : String(error)}`
		});
	}
};
